import React, { useEffect, useRef, useState } from "react";
import { useLoadScript } from "@react-google-maps/api";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { Button, Grid, Switch } from "@mui/material";
import toast from "react-hot-toast";
import { useGooglePlace } from "context/GooglePlaceContext";

const libraries = ["places"];

const GoogleReviews = ({ formData, enable }) => {
    const [place, setPlace] = useState(null);
    const { placeId, setPlaceId } = useGooglePlace();
    const [showGoogleReview, setShowGoogleReview] = useState(
        formData?.show_google_review
    );
    
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const AppService = useAppServices();
    const [agency] = useAgencyInfo();
    const apiKey = agency?.google_api_key;
    const [loading, setLoading] = useState(false);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: apiKey || "",
        libraries,
    });
    useEffect(() => {
        setShowGoogleReview(formData?.show_google_review);

        if (formData?.google_place_id) {
            setPlaceId(formData.google_place_id);
            if (isLoaded && window.google?.maps?.places) {
                const service = new window.google.maps.places.PlacesService(
                    document.createElement("div")
                );
                service.getDetails(
                    { placeId: formData.google_place_id },
                    (result, status) => {
                        if (
                            status === window.google.maps.places.PlacesServiceStatus.OK &&
                            result
                        ) {
                            setPlace(result);
                            setInputValue(result.name || ""); // show business name in input
                        }
                    }
                );
            }
        } else {
            setInputValue("");
            setPlaceId(null);
            setPlace(null);
        }
    }, [formData, setPlaceId, isLoaded]);

    // Initialize Autocomplete
    useEffect(() => {
        if (
            isLoaded &&
            window.google?.maps?.places &&
            inputRef.current
        ) {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(
                inputRef.current
            );
            autocompleteRef.current.addListener("place_changed", () => {
                const selectedPlace = autocompleteRef.current.getPlace();
                if (selectedPlace?.geometry) {
                    setPlace(selectedPlace);
                    setPlaceId(selectedPlace.place_id);
                    setInputValue(selectedPlace.name || "");
                } else {
                    // Clear values if no valid place selected
                    setPlace(null);
                    setPlaceId(null);
                    setInputValue("");
                }
            });
        }
    }, [isLoaded, showGoogleReview, setPlaceId]);

    // Handle manual input changes
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        // Clear place data if input is empty
        if (!value.trim()) {
            setPlace(null);
            setPlaceId(null);
        }
    };

    const savePlaceId = async () => {
        setLoading(true);
        if (!placeId) return;
        const payload = { _id: formData.id, google_place_id: placeId };
        try {
            const { response } = await AppService.accounts.update({ payload });
            if (response) {
                setLoading(false);
                toast.success("Updated successfully");
            }
        } catch (err) {
            setLoading(false);
            toast.error(err);
        }
    };

    return (
        <div style={{ marginBottom: "20px" }}>
            <div>
                <label className="text-black">Link to Google Business Profile</label>
                <input
                    ref={inputRef}
                    id="place-input"
                    type="text"
                    className="form-control-agust"
                    placeholder="Type a place name"
                    value={inputValue}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    );
};

export default GoogleReviews;